import type React from 'react'
import { Horizontal, Vertical, Texto } from '@gravitate-js/excalibrr'
import { FooterTotal } from './FooterTotal'

interface InvoiceTotalsSectionProps {
  productTotal: number
  taxTotal: number
  grandTotal: number
}

export const InvoiceTotalsSection: React.FC<InvoiceTotalsSectionProps> = ({ productTotal, taxTotal, grandTotal }) => {
  return (
    <Vertical gap={12} flex='0 0 auto' justifyContent='flex-end' alignItems='flex-end' className='pt-3 pr-3 pb-3'>
      <Horizontal gap={8} justifyContent='flex-end'>
        <Texto category='h5' style={{ width: 150 }}>
          Product Total:
        </Texto>
        <FooterTotal value={productTotal} />
      </Horizontal>
      <Horizontal gap={8} justifyContent='flex-end'>
        <Texto category='h5' style={{ width: 150 }}>
          Tax Total:
        </Texto>
        <FooterTotal value={taxTotal} />
      </Horizontal>
      <Horizontal gap={8} justifyContent='flex-end'>
        <Texto category='h5' style={{ width: 150 }} weight='bold'>
          Grand Total:
        </Texto>
        <FooterTotal value={grandTotal} />
      </Horizontal>
    </Vertical>
  )
}
